import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { StyledH1 } from './HeaderTitleStyle'

const HeaderTitle = ({ value }) => {
  const { t } = useTranslation()

  return (
    <StyledH1>{t(value)}</StyledH1>
  )
}

HeaderTitle.propTypes = {
  value: PropTypes.string
}
export default HeaderTitle 